// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Print: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path d="M22.41,8.07h-1.06V6.42c0-0.71-0.58-1.29-1.29-1.29h-1.18v1.4h1.06v1.54h-1.54V2.19H5.59v5.88H4.05V6.53h1.06v-1.4H3.94
	c-0.71,0-1.29,0.58-1.29,1.29v1.65H1.59c-0.71,0-1.29,0.58-1.29,1.29v8.23c0,0.71,0.58,1.29,1.29,1.29h3.53v-1.4H1.7v-1.54h20.6
	v1.54h-3.41v1.4h3.53c0.71,0,1.29-0.58,1.29-1.29V9.36C23.7,8.65,23.12,8.07,22.41,8.07z M6.99,3.59h10.02v4.48H6.99V3.59z
	 M1.7,14.53V9.47h20.6v5.06H1.7z"/>
<polygon points="17.01,20.41 6.99,20.41 6.99,16.41 5.59,16.41 5.59,21.81 18.41,21.81 18.41,16.41 17.01,16.41 "/>
</svg>;
};

export default React.memo(Print);
